import View from '@/components/common/view'
// 同线工人
import index from '../components/lineWork/index'
import employerEdit from '../components/lineWork/edit'
import employerFillin from '../components/lineWork/fillin'
import employerConfirm from '../components/lineWork/confirm'
import success from '../components/lineWork/success.vue'
import editSuccess from '../components/lineWork/editsuccess.vue'
export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'index',
				component:index
			},
			{
				path:'fillin/:id?',
				component:employerFillin
			},
			{
				path:'edit/:id',
				component:employerEdit
			},
			{
				path:'confirm/:id?',
				component:employerConfirm
			},
            {
				path:'success/:id?',
				component:success
			},
            {
				path:'editSuccess/:id?',
				component:editSuccess
			}
		]
	}
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/lineWork.js